import React, { useState, useContext, useEffect } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { TextField, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Import Spanish locale for dayjs
import RoomTypeRatePlanContext from '../contexts/RoomTypeRatePlanContext';
import Cookies from 'js-cookie';
import {obtenerDatosHotel} from '../../services/motorService';
const Calendar2 = () => {
    const today = dayjs();
    const { selectedDetails, setSelectedDetails } = useContext(RoomTypeRatePlanContext);
    const [startDate, setStartDate] = useState(dayjs(selectedDetails.startDate));
    const [endDate, setEndDate] = useState(dayjs(selectedDetails.endDate));
    const [minNights, setMinNights] = useState(1); // Valor por defecto

    const hotCod = Cookies.get('hotCod');

    const [openEndDatePicker, setOpenEndDatePicker] = useState(false);
    const [endError, setEndError] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        setStartDate(dayjs(selectedDetails.startDate));
        setEndDate(dayjs(selectedDetails.endDate));
    }, [selectedDetails]);

    useEffect(() => {
        // Extraer noches mínimas del contexto
        const fetchMinNights = async () => {
            try {
                const hotelData = await obtenerDatosHotel(hotCod); // Adaptar según tu estructura
                setMinNights(hotelData.motorhotminimonoches || 1);
            } catch (error) {
                console.error("Error fetching minimum nights:", error);
            }
        };
        fetchMinNights();
    }, []);


    /*const handleStartDateChange = (newDate) => {
        if (newDate.isBefore(today, 'day')) {
            setStartDate(today);
            setEndDate(today.add(2, 'day'));
            setSelectedDetails(prev => ({ ...prev, startDate: today.toDate(), endDate: today.add(2, 'day').toDate() }));
        } else {
            setStartDate(newDate);
            if (newDate.isAfter(endDate) || newDate.isSame(endDate, 'day')) {
                const newEndDate = newDate.add(1, 'day');
                setEndDate(newEndDate);
                setSelectedDetails(prev => ({ ...prev, startDate: newDate.toDate(), endDate: newEndDate.toDate() }));
                setOpenEndDatePicker(true); // Open end date picker
            } else {
                setSelectedDetails(prev => ({ ...prev, startDate: newDate.toDate(), endDate: endDate.toDate() }));
                setOpenEndDatePicker(true); // Open end date picker
            }
        }
        setEndError(false);
    };*/

    const handleStartDateChange = (newDate) => {
        if (newDate.isBefore(today, 'day')) {
            return; // No permitir fechas pasadas
        }

        setStartDate(newDate);

        const adjustedEndDate = newDate.add(minNights, 'day');
        setEndDate(adjustedEndDate);
        setSelectedDetails(prev => ({
            ...prev,
            startDate: newDate.toDate(),
            endDate: adjustedEndDate.toDate(),
        }));
    };

    /*const handleEndDateChange = (newDate) => {
        if (newDate.isBefore(startDate.add(1, 'day'))) {
            setEndError(true);
        } else {
            setEndError(false);
            setEndDate(newDate);
            setSelectedDetails(prev => ({ ...prev, startDate: startDate.toDate(), endDate: newDate.toDate() }));
            setOpenEndDatePicker(false); // Close end date picker
        }
    };
*/
    const handleEndDateChange = (newDate) => {
        const minValidEndDate = startDate.add(minNights, 'day');
        if (newDate.isBefore(minValidEndDate)) {
            const adjustedEndDate = minValidEndDate;
            setEndDate(adjustedEndDate);
            setSelectedDetails(prev => ({
                ...prev,
                endDate: adjustedEndDate.toDate(),
            }));
        } else {
            setEndDate(newDate);
            setSelectedDetails(prev => ({
                ...prev,
                endDate: newDate.toDate(),
            }));
        }
    };
    const disableStartDate = (date) => {
        return date.isBefore(today, 'day'); // Deshabilitar fechas pasadas
    };
    const disableEndDate = (date) => {
        const minValidEndDate = startDate.add(minNights, 'day');
        return date.isBefore(minValidEndDate, 'day'); // Deshabilitar fechas antes del rango permitido
    };

    const DatePickerComponent = isMobile ? MobileDatePicker : DesktopDatePicker;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <DatePickerComponent
                        value={startDate}
                        onChange={handleStartDateChange}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                        inputFormat="DD/MM/YYYY" // Format day/month/year
                        minDate={today} // Ensure start date is not before today
                        shouldDisableDate={disableStartDate}
                        sx={{width: '100%'}}
                    />
                </Grid>
                <Grid item xs={6}>
                    
                    <DatePickerComponent
                        value={endDate}
                        onChange={handleEndDateChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                error={endError}
                                helperText={`Debe seleccionar al menos ${minNights} noches`}
                            />
                        )}
                        open={openEndDatePicker}
                        onOpen={() => setOpenEndDatePicker(true)} // Allow manual opening
                        onClose={() => setOpenEndDatePicker(false)}
                        minDate={startDate.add(1, 'day')} // Ensure end date is always after start date
                        shouldDisableDate={disableEndDate}
                        inputFormat="DD/MM/YYYY" // Format day/month/year
                        sx={{width: '100%'}}
                        
                    />
                </Grid>
            </Grid>
        </LocalizationProvider>
    );
};

export default Calendar2;